import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius)] text-sm font-semibold transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-brand text-white shadow-card hover:bg-brand/90 active:bg-brand/80",
        destructive:
          "bg-error text-white shadow-card hover:bg-error/90 active:bg-error/80",
        outline:
          "border border-brand/25 bg-transparent text-brand shadow-card hover:bg-brand/10 active:bg-brand/20 dark:border-brand/40 dark:text-brand-2",
        secondary:
          "bg-brand/10 text-brand shadow-card hover:bg-brand/20 active:bg-brand/30 dark:text-brand-2 dark:bg-slate-800",
        ghost:
          "text-brand hover:bg-brand/10 active:bg-brand/20 dark:text-brand-2 dark:hover:bg-brand/20",
        link: "text-brand underline-offset-4 hover:underline",
      },
      size: {
        default: "min-h-[44px] px-4 py-2",
        sm: "min-h-[40px] rounded-[calc(var(--radius)-4px)] px-3 text-xs",
        lg: "min-h-[48px] px-6 text-base",
        icon: "h-11 w-11 min-h-[44px] min-w-[44px] rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
